export const confirmConstants = {
    SHOW_CONFIRM_MODAL: 'SHOW_CONFIRM_MODAL',
    HIDE_CONFIRM_MODAL: 'HIDE_CONFIRM_MODAL',
};
